<script>
  import SearchSelect from "@/core/components/SearchSelect.vue"
  import TariffCoefficientService from "@/domains/lines/services/TariffCoefficientService"
  import { faTimesCircle } from "@fortawesome/free-solid-svg-icons"
  import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
  import { lowerCase } from "lodash"
  import moment from "moment"
  import { Money } from "v-money"
  import Datepicker from "vuejs-datepicker"
  import { ptBR } from "vuejs-datepicker/dist/locale"
  export default {
    components: {
      SearchSelect,
      Datepicker,
      FontAwesomeIcon,
      Money,
    },
    props: {
      tariffCoefficientModel: {
        type: Object,
        required: true,
      },
    },
    data: () => ({
      faTimesCircle,
      locale: ptBR,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 5,
      },
      moneyTwoDecimals: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
      },
      percentage: {
        decimal: ",",
        thousands: ".",
        suffix: " %",
        precision: 2,
        masked: true,
      },
      transportadora: {
        id: null,
        name: "",
      },
      ultimoCoeficiente: {
        tariffCoefficient: {
          idcoeficientetarifa: null,
          nutransportadora: null,
          dtcadastro: null,
          dtiniciovalidade: null,
          dtfimvalidade: null,
          dtalteracao: null,
          flsituacao: "",
          deter_registry: {
            organization_id: null,
            status_id: null,
            type_id: null,
            field_activity_id: null,
            expire_at: null,
            created_at: null,
            updated_at: null,
            deleted_at: null,
          },
          valores: [],
        },
      },
      patamares: [],
      naoPatamarizados: [
        {
          tipo: 1,
          coeficienteAtual: "",
          indiceRevisao: "",
          coeficienteAtualizado: "",
        },
        {
          tipo: 2,
          coeficienteAtual: "",
          indiceRevisao: "",
          coeficienteAtualizado: "",
        },
        {
          tipo: 3,
          coeficienteAtual: "",
          indiceRevisao: "",
          coeficienteAtualizado: "",
        },
        {
          tipo: 4,
          coeficienteAtual: "",
          indiceRevisao: "",
          coeficienteAtualizado: "",
        },
        {
          tipo: 5,
          valor: "",
        },
        {
          tipo: 6,
          valor: "",
        },
      ],
      romanNumerals: [
        ["X", 10],
        ["IX", 9],
        ["V", 5],
        ["IV", 4],
        ["I", 1],
      ],

      tariffCoefficientService: new TariffCoefficientService(),
    }),
    computed: {
      tariffCoefficientForm() {
        return this.tariffCoefficientModel
      },
    },
    watch: {
      tariffCoefficientModel: {
        handler() {
          this.transportadora = {
            id: this.tariffCoefficientModel.transportadoraForm.id ?? null,
            name: this.tariffCoefficientModel.transportadoraForm.name ?? "",
          }
        },
        deep: true,
      },
      ultimoCoeficiente: {
        handler() {
          this.patamares = []
          this.naoPatamarizados = [
            {
              // Rodoviário piso I
              tipo: 1,
              coeficienteAtual: "",
              indiceRevisao: "",
              coeficienteAtualizado: "",
            },
            {
              // Rodoviário piso II
              tipo: 2,
              coeficienteAtual: "",
              indiceRevisao: "",
              coeficienteAtualizado: "",
            },
            {
              // Urbano piso I
              tipo: 3,
              coeficienteAtual: "",
              indiceRevisao: "",
              coeficienteAtualizado: "",
            },
            {
              // Urbano piso II
              tipo: 4,
              coeficienteAtual: "",
              indiceRevisao: "",
              coeficienteAtualizado: "",
            },
            {
              // Tarifa mínima Rodoviário
              tipo: 5,
              coeficienteAtualizado: "",
            },
            {
              // Tarifa mínima Urbano
              tipo: 6,
              coeficienteAtualizado: "",
            },
          ]
          this.tariffCoefficientForm.vlarredondamentotarifa =
            this.ultimoCoeficiente.vlarredondamentotarifa
          this.ultimoCoeficiente.valores.forEach((valor) => {
            // 7 == patamarizada
            if (valor.nutipopreco === 7) {
              this.patamares.push({
                nuordemtipopreco: valor.nuordemtipopreco,
                coeficienteAtual: valor.vltarifa.slice(0, -3),
                coeficienteAtualizado: valor.vltarifa.slice(0, -3),
              })
            } else {
              switch (valor.nutipopreco) {
                // 1 == rodoviário piso I
                case 1:
                  this.naoPatamarizados[0].coeficienteAtual = valor.vltarifa
                  this.naoPatamarizados[0].coeficienteAtualizado =
                    valor.vltarifa
                  break
                // 2 == rodoviário piso II
                case 2:
                  this.naoPatamarizados[1].coeficienteAtual = valor.vltarifa
                  this.naoPatamarizados[1].coeficienteAtualizado =
                    valor.vltarifa
                  break
                // 3 == urbano piso I
                case 3:
                  this.naoPatamarizados[2].coeficienteAtual = valor.vltarifa
                  this.naoPatamarizados[2].coeficienteAtualizado =
                    valor.vltarifa
                  break
                // 4 == urbano piso II
                case 4:
                  this.naoPatamarizados[3].coeficienteAtual = valor.vltarifa
                  this.naoPatamarizados[3].coeficienteAtualizado =
                    valor.vltarifa
                  break
                // 5 == tarifa mínima rodoviário
                case 5:
                  this.naoPatamarizados[4].coeficienteAtualizado =
                    valor.vltarifa.slice(0, -3)
                  this.naoPatamarizados[4].coeficienteAtualizado =
                    valor.vltarifa.slice(0, -3)
                  break
                // 6 == tarifa mínima urbano
                case 6:
                  this.naoPatamarizados[5].coeficienteAtualizado =
                    valor.vltarifa.slice(0, -3)
                  this.naoPatamarizados[5].coeficienteAtualizado =
                    valor.vltarifa.slice(0, -3)
                  break
                default:
                  break
              }
            }
          })
        },
        deep: true,
      },
    },
    methods: {
      submitTariffCoefficientForm() {
        this.tariffCoefficientForm.valores = []
        this.tariffCoefficientForm.deprocesso =
          this.tariffCoefficientForm.deprocesso
        this.tariffCoefficientForm.deresolucao =
          this.tariffCoefficientForm.deresolucao

        this.naoPatamarizados.forEach((naoPatamarizado) => {
          this.tariffCoefficientForm.valores.push({
            vltarifa: naoPatamarizado.coeficienteAtualizado,
            nutipopreco: naoPatamarizado.tipo,
            nuordemtipopreco: null,
            tipo: {
              idtipopreco: naoPatamarizado.tipo,
            },
          })
        })
        this.patamares.forEach((patamar) => {
          this.tariffCoefficientForm.valores.push({
            vltarifa: patamar.coeficienteAtualizado,
            nutipopreco: 7,
            nuordemtipopreco: patamar.nuordemtipopreco,
            tipo: {
              idtipopreco: 7,
            },
          })
        })
        this.$emit("submit")
      },

      /**
       * Formata a string para capitalizar a primeira letra de cada palavra
       * @param string
       */
      capitalize(string) {
        let arrayPalavras = string.split(" ")
        let arrayPalavrasCapitalized = arrayPalavras.map((palavra) => {
          return palavra.charAt(0).toUpperCase() + lowerCase(palavra.slice(1))
        })
        return arrayPalavrasCapitalized.join(" ")
      },

      /**
       * Converte um número para algarismos romanos
       * @param num
       */
      toRomanNumeral(num) {
        let number = this.romanNumerals.reduce((acc, [k, v]) => {
          acc += k.repeat(Math.floor(num / v))
          num = num % v
          return acc
        }, "")
        return number
      },

      /**
       * Altera a transportadora selecionada
       * @param transportadora
       */
      changeNuTransportadora(transportadora) {
        this.tariffCoefficientForm.nutransportadora = transportadora.id
        this.tariffCoefficientForm.transportadoraForm = {
          id: transportadora.id,
          name: this.capitalize(transportadora.business_name),
        }
        this.tariffCoefficientService
          .getLastTariffCoefficient(transportadora.id)
          .then((response) => {
            if (response.length === 0) {
              this.$toast.warning({
                title: "Aviso",
                message:
                  "Não foi encontrado nenhum coeficiente tarifário para essa transportadora.",
                icon: "fa fa-exclamation",
              })
              this.dtultimaatualizacao = ""
              return
            }
            if (response[0].flsituacao == 3) {
              this.$toast.error({
                title: "Erro",
                message:
                  "Essa transportadora possui um coeficiente tarifário aguardando início de vigência.",
              })
            }
            this.ultimoCoeficiente = response[0]
            this.ultimoCoeficiente.dtcadastro = this.dateFormat(
              this.ultimoCoeficiente.dtcadastro
            )
          })
      },

      /**
       * Altera o valor do coeficiente não patamarizado
       * @param e
       */
      toggleList(type) {
        // define refs como um array de keys
        Object.keys(this.$refs).forEach((key) => {
          if (key.includes("submitButton")) {
            return
          }

          // verifica se a key contém o tipo selecionado
          if (key.includes(type)) {
            // se list, remove a classe hidden
            if (key.includes("section")) {
              this.$refs[key].classList.remove("hidden")
            } else {
              // se button, adiciona a classe selected-button e
              this.$refs[key].classList.add("selected-button")
              // remove a classe non-selected-button
              this.$refs[key].classList.remove("non-selected-button")
            }
            // se não contém o tipo selecionado
          } else {
            // se list, adiciona a classe hidden
            if (key.includes("section")) {
              this.$refs[key].classList.add("hidden")
            } else {
              // se button, remove a classe selected-button e
              this.$refs[key].classList.remove("selected-button")
              // adiciona a classe non-selected-button
              this.$refs[key].classList.add("non-selected-button")
            }
          }
        })
      },
      addPatamar() {
        let i = this.patamares.length
        this.patamares.push({
          nuordemtipopreco: i + 1,
          coeficienteAtual: "",
          coeficienteAtualizado: "",
        })
      },
      removePatamar(index) {
        this.patamares.splice(index, 1)
        this.patamares.forEach((patamar) => {
          if (patamar.nuordemtipopreco > index + 1) {
            patamar.nuordemtipopreco = patamar.nuordemtipopreco - 1
          }
        })
      },
      dateFormat(date) {
        return moment(date).format("DD/MM/YYYY")
      },
      /**
       * Função genérica para alterar o valor do coeficiente não patamarizado de acordo
       * com o campo preenchido
       * @param tipo O tipo do valor a ser alterado
       */
      changeValorNaoPatamarizado(tipo) {
        let valorAtual = this.naoPatamarizados[tipo - 1].coeficienteAtual
        let percentual = parseFloat(
          this.naoPatamarizados[tipo - 1].indiceRevisao.slice(0, -2)
        )
        this.naoPatamarizados[tipo - 1].coeficienteAtualizado = parseFloat(
          valorAtual * (percentual / 100) + valorAtual
        )

        this.ultimoCoeficiente.valores.forEach((valorForm) => {
          if (valorForm.nutipopreco === tipo) {
            if (
              this.tariffCoefficientForm.valores.length === 0 ||
              !this.tariffCoefficientForm.valores.some(
                (valorModel) => valorModel.nutipopreco === tipo
              )
            ) {
              this.tariffCoefficientForm.valores.push({
                vltarifa: this.naoPatamarizados[tipo - 1].coeficienteAtualizado,
                nutipopreco: tipo,
                nuordemtipopreco: valorForm.nuordemtipopreco,
                tipo: {
                  idtipopreco: tipo,
                },
              })
            } else {
              this.tariffCoefficientForm.valores.forEach((valorModel) => {
                if (valorModel.nutipopreco === tipo) {
                  valorModel.vltarifa =
                    this.naoPatamarizados[tipo - 1].coeficienteAtualizado
                }
              })
            }
          }
        })
      },
      /**
       * Função genérica para alterar o valor do coeficiente patamarizado de acordo
       * com o campo preenchido
       * @param patamar O patamar a ser alterado
       */
      changeValorPatamarizado(patamar) {
        if (
          this.tariffCoefficientForm.valores.length === 0 ||
          !this.tariffCoefficientForm.valores.some(
            (valorModel) =>
              valorModel.nutipopreco === 7 &&
              valorModel.nuordemtipopreco === this.patamares[patamar].patamar
          )
        ) {
          this.tariffCoefficientForm.valores.push({
            vltarifa: this.patamares[patamar].valorAtualizado,
            nutipopreco: 7,
            nuordemtipopreco: patamar + 1,
            tipo: {
              idtipopreco: 7,
            },
          })
        } else {
          this.tariffCoefficientForm.valores.forEach((valorModel) => {
            if (
              valorModel.nutipopreco === 7 &&
              valorModel.nuordemtipopreco === this.patamares[patamar].patamar
            ) {
              valorModel.vltarifa = this.patamares[patamar].valorAtualizado
            }
          })
        }
      },
    },
  }
</script>
<template>
  <form
    class="flex flex-col gap-6"
    @submit.prevent="submitTariffCoefficientForm"
  >
    <!-- Seção Superior: Transportadora e Datas -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 border-b pb-6">
      <div class="md:col-span-2">
        <label class="form-label" for="transportadora">Transportadora</label>
        <SearchSelect
          :selected.sync="transportadora"
          :search-keys="[]"
          :search-remote="true"
          :lazy-load="true"
          options-url="/api/registry/organizations/"
          :digits-before-search="3"
          option-key="transportadora"
          field-class="py-2.5"
          name="organization"
          :option-value="
                        transportadora => capitalize(transportadora.name)
                    "
          @changed="changeNuTransportadora"
        />
      </div>
      <div>
        <label class="form-label" for="dtultimaatualizacao">
          Última Atualização
        </label>
        <input
          id="dtultimaatualizacao"
          v-model="ultimoCoeficiente.dtcadastro"
          type="text"
          class="form-input disabled"
          disabled
        >
      </div>
    </div>

    <!-- Seção Meio: Refatorada em 2 linhas -->
    <div class="flex flex-col gap-6 border-b pb-6">
      <!-- Linha 1: Arredondamento, Vigência, Tarifa Mínima -->
      <div
        class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 items-end"
      >
        <div>
          <label class="form-label" for="arredondamento">Arredondamento</label>
          <money
            v-model="tariffCoefficientForm.vlarredondamentotarifa"
            v-bind="moneyTwoDecimals"
            class="form-input"
          />
        </div>
        <div>
          <label class="form-label" for="dtiniciovalidade">
            Início da Vigência
          </label>
          <Datepicker
            id="dtiniciovalidade"
            v-model="tariffCoefficientForm.dtiniciovalidade"
            format="dd/MM/yyyy"
            :language="locale"
            :full-month-name="true"
            input-class="form-input mb-0"
          />
        </div>
        <div class="flex flex-col gap-2">
          <label class="form-label">Tarifa Mínima</label>
          <div class="flex flex-col sm:flex-row gap-4">
            <div class="flex items-center gap-2">
              <label class="font-medium text-gray-700">Rodoviário</label>
              <money
                v-model="
                                    naoPatamarizados[4].coeficienteAtualizado
                                "
                v-bind="moneyTwoDecimals"
                class="form-input mb-0"
              />
            </div>
            <div class="flex items-center gap-2">
              <label class="font-medium text-gray-700">Urbano</label>
              <money
                v-model="
                                    naoPatamarizados[5].coeficienteAtualizado
                                "
                v-bind="moneyTwoDecimals"
                class="form-input mb-0"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- Linha 2: Processo e Resolução -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="form-label" for="deprocesso">Processo SGPE</label>
          <input
            id="deprocesso"
            v-model="tariffCoefficientForm.deprocesso"
            type="text"
            class="form-input"
          >
        </div>
        <div>
          <label class="form-label" for="deresolucao">Resolução</label>
          <input
            id="deresolucao"
            v-model="tariffCoefficientForm.deresolucao"
            type="text"
            class="form-input"
          >
        </div>
      </div>
    </div>

    <!-- Botões de Navegação (Tabs) -->
    <div class="grid grid-cols-2 gap-2 text-lg">
      <button
        ref="buttonFirstPage"
        type="button"
        class="col-span-1 selected-button first-button text-center content-center h-16 uppercase shadow-md rounded-md"
        @click="toggleList('FirstPage')"
      >
        Não Patamarizadas
      </button>
      <button
        ref="buttonSecondPage"
        type="button"
        class="col-span-1 non-selected-button text-center content-center h-16 uppercase shadow-md rounded-md"
        @click="toggleList('SecondPage')"
      >
        Patamarizadas
      </button>
    </div>

    <!-- Seção Não Patamarizadas -->
    <div ref="sectionFirstPage" class="shadow-md rounded-md border">
      <!-- Cabeçalho -->
      <div
        class="hidden md:grid md:grid-cols-4 bg-gray-200 rounded-t-md text-sm font-bold"
      >
        <div class="p-2">TIPO DE RODOVIA</div>
        <div class="p-2">COEFICIENTE ATUAL</div>
        <div class="p-2">ÍNDICE DE REVISÃO</div>
        <div class="p-2">COEFICIENTE ATUALIZADO</div>
      </div>
      <!-- Linhas -->
      <div class="flex flex-col">
        <div
          v-for="item in naoPatamarizados.slice(0, 4)"
          :key="item.tipo"
          class="grid grid-cols-1 md:grid-cols-4 gap-2 p-3 border-b last:border-0"
        >
          <div class="font-semibold flex items-center">
            <span v-if="item.tipo === 1">RODOVIÁRIO PISO I</span>
            <span v-if="item.tipo === 2">RODOVIÁRIO PISO II</span>
            <span v-if="item.tipo === 3">URBANO PISO I</span>
            <span v-if="item.tipo === 4">URBANO PISO II</span>
          </div>
          <div>
            <label class="form-label md:hidden">COEFICIENTE ATUAL</label>
            <money
              v-model="item.coeficienteAtual"
              v-bind="money"
              class="form-input"
              @blur.native="changeValorNaoPatamarizado(item.tipo)"
            />
          </div>
          <div>
            <label class="form-label md:hidden">ÍNDICE DE REVISÃO</label>
            <money
              v-model="item.indiceRevisao"
              v-bind="percentage"
              class="form-input"
              @blur.native="changeValorNaoPatamarizado(item.tipo)"
            />
          </div>
          <div>
            <label class="form-label md:hidden">COEFICIENTE ATUALIZADO</label>
            <money
              v-model="item.coeficienteAtualizado"
              v-bind="money"
              class="form-input"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Seção Patamarizadas -->
    <div
      ref="sectionSecondPage"
      class="shadow-md rounded-md border col-span-6 hidden"
    >
      <!-- Cabeçalho -->
      <div
        class="hidden md:grid md:grid-cols-4 bg-gray-200 rounded-t-md text-sm font-bold"
      >
        <div class="p-2 text-center">PATAMAR</div>
        <div class="p-2">VALOR ATUAL DO PATAMAR</div>
        <div class="p-2">VALOR ATUALIZADO DO PATAMAR</div>
        <div class="p-2"></div>
      </div>
      <!-- Linhas -->
      <div class="flex flex-col">
        <div
          v-for="(patamar, i) in patamares"
          :key="i"
          class="grid grid-cols-1 md:grid-cols-4 gap-2 p-3 items-center border-b last:border-0"
        >
          <div class="font-semibold text-center">
            {{ toRomanNumeral(i + 1) }}
            <input v-model="patamar.nuordemtipopreco" type="hidden">
          </div>
          <div>
            <label class="form-label md:hidden">VALOR ATUAL</label>
            <money
              v-model="patamar.coeficienteAtual"
              v-bind="moneyTwoDecimals"
              class="form-input disabled"
              disabled
            />
          </div>
          <div>
            <label class="form-label md:hidden">VALOR ATUALIZADO</label>
            <money
              v-model="patamar.coeficienteAtualizado"
              v-bind="moneyTwoDecimals"
              class="form-input"
              @blur.native="changeValorPatamarizado(i)"
            />
          </div>
          <div class="flex justify-center md:justify-start">
            <button type="button" @click="removePatamar(i)">
              <FontAwesomeIcon
                class="text-red-500 cursor-pointer"
                size="lg"
                :icon="faTimesCircle"
              />
            </button>
          </div>
        </div>
      </div>
      <!-- Botão Novo Patamar -->
      <div class="flex justify-end p-3 md:justify-end">
        <button
          class="form-submit w-full md:w-auto"
          type="button"
          @click="addPatamar"
        >
          Novo Patamar
        </button>
      </div>
    </div>

    <!-- Botão Salvar -->
    <div class="flex mt-4 md:justify-end">
      <button
        ref="submitButton"
        type="submit"
        class="form-submit bg-green-profile w-full md:w-auto"
      >
        Salvar
      </button>
    </div>
  </form>
</template>
